module.exports = __webpack_public_path__ + "static/media/section03_3.f93b22c5.jpg";